import React from "react";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Administration() {
    const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{ display:'flex',alignItems:'center',justifyContent:'center',background:'orange', backgroundSize: 'cover', backgroundPosition: 'center',height:'400px' }}>
      <img src="./images/maruthi.png" alt="image" style={{width:'20%'}} />
      </div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <h1>Administration</h1>
        <div className="row">
            <div className="col-md-12 imagebox">
                <div className="row" >
                    <div className="col-md-4 " style={{ backgrooundPosition: 'left', backgroundSize: 'cover', padding: '10px !important' }}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/melsanthi.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">{t("vishnu_name")}</p>
                            <p className="designation">{t("vishnu_designation")}</p>
                            <p style={{textAlign:'center',fontWeight:'600',color:'black'}}>{t("vishnu_phone")}</p>
                        </div>
                    </div>
                    <div className="col-md-8 " >
						{/* <img src="./images/melsanthi.jpeg" alt="Melsanthi" style={{width:'100%',marginBottom:'20px'}} />
						<h3 className="hheading">ശ്രീകൃഷ്ണ മാരുതിക്ഷേത്രം മേൽശാന്തി</h3> */}
						<p className="about">
                        {t("vishnu_profile")}
                            {/* ചെറുപ്പം മുതലേ സാമുഹിക പ്രതിബദ്ധത നാമ്പിട്ടിരുന്ന ശ്രീവിഷ്ണുശാന്തി സ്വന്തം വിവാഹത്തിന് ആഡംബരങ്ങളൊക്കെ ഒഴിവാക്കി അതേ വേദിയിൽ നിർദ്ധനയായ മറ്റൊരു പെൺകുട്ടിക്ക് മാംഗല്യ സൗഭാഗ്യമൊരുക്കി സമുഹത്തിന് മാത്യകയായി. അമ്മ സജിത. <br />
							ഭാര്യ: അശ്വതി. മക്കൾ: ബജ്‌രംഗ്, രുദ്രാക്ഷ്. കൃഷിയിൽ സജീവമായ വിഷ്ണുശാന്തിയ്ക്ക് എടവിലങ്ങ് പഞ്ചായത്തിലെ യുവകർഷകനുള്ള പുരസ്ക്കാരവും (2024) ലഭിച്ചു. ശ്രീനാരായണ ഗുരു ദേവ ധർമ്മങ്ങളിൽ അധിഷ്ഠിതമായ പൂജാദികർമ്മങ്ങളും ആത്മീയ ആശയങ്ങളും ഭക്തജന ങ്ങളിലേക്ക് പകർന്നു നൽകുകയും ഇന്ന് കൊടുങ്ങല്ലൂരിലെ പ്രധാന ശാന്തിമാരിൽ ഒരാളായി മാറുകയും ചെയ്തു. ആദ്ധ്യാത്മിക, സാമൂഹ്യസേവന, കാർഷി കമേഖലയിലെല്ലാം വ്യക്തിമുദ്ര പതിപ്പിച്ചാണ് യഥാർത്ഥ ഭക്തിയോടെ, സമർപ്പിതമനസോടെയുളള ഉപാസകനായി വിഷ്ണുശാന്തി ഭഗവാനിൽ സ്വയം സമർപ്പിക്കുന്നത്. */}
						</p>
						{/* <p className="about" style={{padding:'15px',border:'1px solid orange',fontSize:'15pt'}}>
							വിഷ്ണു ശാന്തി <br />
							Ph: +91 81299 81222
						</p> */}
					</div>                    
                </div>
           </div>            
        </div>

        {/* <div className="row">
            <div className="col-md-12">
                <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>Administrative Committee</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/anil.jpg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Sri. Anilkumar K P</p>
                            <p className="designation">Chairman, Additional District & Sessions Judge - I, Trivandrum</p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/Adithya.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Adithya Varma</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/jayan.jpg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Karamana Jayan</p>
                            <p className="designation"></p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/velappan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Adv. A. Velappan Nair</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3" style={{marginTop:'30px'}}>
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/govindan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Govindan Namboodiripad</p>
                            <p className="designation"></p>
                        </div>
                    </div>              
                </div>
           </div>            
        </div> */}


        {/* <div className="row">
            <div className="col-md-12">
                <h3 style={{marginBottom:'30px',fontSize:'20pt'}}>Advisory Committee</h3>
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/justice.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">Justice T R Ramachandran Nair (Rtd.)</p>
                            <p className="designation">Chairman</p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/bala.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">T. Balakrishnan IAS (Rtd.)</p>
                            <p className="designation"></p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./administrators/suresh.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">S Suresh</p>
                            <p className="designation">FCA</p>
                        </div>
                    </div>    
                </div>
           </div>            
        </div> */}


      </div>
    </div>
  );
}

export default Administration;